import { render, staticRenderFns } from "./MenuRedoButton.vue?vue&type=template&id=e73d7116&"
import script from "./MenuRedoButton.vue?vue&type=script&lang=ts&"
export * from "./MenuRedoButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports